import { useTranslation } from 'react-i18next';

const rows = [
  { labelKey: 'compare.row1', oopbuy: 5, other: 3 },
  { labelKey: 'compare.row2', oopbuy: 5, other: 2 },
  { labelKey: 'compare.row3', oopbuy: 5, other: 3 },
  { labelKey: 'compare.row4', oopbuy: 5, other: 2 },
  { labelKey: 'compare.row5', oopbuy: 5, other: 2 },
];

export default function ComparisonTable() {
  const { t } = useTranslation();

  const renderStars = (count: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`ri-star-fill text-sm ${i < count ? 'text-accent-500' : 'text-foreground-200'}`}
      ></i>
    ));
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            {t('compare.title')}
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="grid grid-cols-3 bg-secondary-100 px-6 py-4">
            <span className="text-sm font-semibold text-foreground-900">{t('compare.col1')}</span>
            <span className="text-sm font-semibold text-primary-700 text-center">{t('compare.col2')}</span>
            <span className="text-sm font-semibold text-foreground-600 text-center">{t('compare.col3')}</span>
          </div>
          {rows.map((row, idx) => (
            <div
              key={row.labelKey}
              className={`grid grid-cols-3 px-6 py-4 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100'}`}
            >
              <span className="text-sm text-foreground-800">{t(row.labelKey)}</span>
              <span className="flex items-center justify-center gap-0.5">{renderStars(row.oopbuy)}</span>
              <span className="flex items-center justify-center gap-0.5">{renderStars(row.other)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}